export function TileItem(
  id = '',
  file = '',
  caption = '',
  link = '',
  order,
  modified = false
) {
  this.id = id;
  this.file = file;
  this.caption = caption;
  this.link = link;
  this.order = order;
  this.modified = modified;
}
